export default "__VITE_ASSET__CAW6wW5x__"